import React from 'react';
import { IonPage, useIonRouter } from '@ionic/react';
import { AppHeader_v2 as AppHeader, IconArrowLeft, IconButton } from '@mindly/ui-components';

import { ProfileCountryOfLivingWidget } from '../../widgets';
import { useUpdateProfile } from '../../shared/hooks/useUpdateProfile';

export function CountryOfLivingPage() {
  const { successfullyUpdatedProfile } = useUpdateProfile();
  const router = useIonRouter();

  return (
    <IonPage>
      <AppHeader className="flex flex-row items-start mb-4 cursor-pointer">
        <IconButton icon={<IconArrowLeft />} onClick={() => router.goBack()} />
      </AppHeader>
      <ProfileCountryOfLivingWidget
        onSuccess={() => {
          successfullyUpdatedProfile(true);
        }}
      />
    </IonPage>
  );
}
